import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment';
import './style.css';
import { LoadingAnimation } from '../loading-animation';
import { getShowReserveInfo, CancellReservation, SendReservationEmail } from '../api/clientform';
import CalendarIcon from '../icon/orangeCalendar.svg';
import PlaceIcon from '../icon/orangePlace.svg';
import UserIcon from '../icon/orangeUser.svg';
import PhoneIcon from '../icon/phone.svg';
import TgIcon from '../icon/tgLogo.svg';
import { getMomentTimeFromUTC } from '../time-manipulations';


function ShowReserve() {
    const [address, setAddress] = useState('');
    const [restaurantName, setRestaurantName] = useState<string>();
    const [date, setDate] = useState<string>();
    const [phone, setPhone] = useState<string>();
    const [guests, setGuests] = useState(1);
    const [status, setStatus] = useState<string>();
    const [searchParams, setSearchParams] = useSearchParams();
    const [email, setEmail] = useState('');
    const [emailMessage, setEmailMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const reserveId = searchParams.get('reserveId');

    const sendEmail = () => {
        if (validateEmail(email)) {
            setIsLoading(true);
            reserveId && SendReservationEmail(reserveId, email).then(() => {
                setEmailMessage('Письмо успешно отправлено!');
            }).finally(() => {
                setIsLoading(false);
            });
        } else {
            setEmailMessage('Неверный формат email');
        }
    };

    const sendTelegram = () => {
        let url = window.location.origin.includes('bambook.place') ? 'https://t.me/bambookguestbot?start=' + reserveId : 'https://t.me/bambookclienttestbot?start=' + reserveId;
        window.open(url, '_blank')?.focus();
    };

    const getStatusSpan = () => {
        switch (status) {
            case 'Отменено гостем':
            case 'Отменено администратором':
                return (<span className="message__status message__cancelled active-inline">Отменено</span>);
            case 'Не подтверждено':
                return (<span className="message__status message__unconfirm active-inline">Ожидает подтверждения администратором</span>);
            case 'Завершено':
                return (<span className="message__status message__confirm active-inline">Завершено</span>);
            default:
                return (<span className="message__status message__confirm active-inline">Подтверждено - ждём вас</span>);
        }
    };

    const cancellReserve = () => {
        if (window.confirm("Вы действительно хотите отменить бронирование?")) {
            setIsLoading(true);
            if (reserveId) {
                CancellReservation(reserveId).then(() => {
                    window.location.reload();
                }).finally(() => {
                    setIsLoading(false);
                });
            }
        }

    };

    const validateEmail = (email: string) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    useEffect(() => {
        setIsLoading(true);
        reserveId &&
            getShowReserveInfo(reserveId).then(data => {
                setRestaurantName(data.name);
                setAddress(data.address);
                setDate(data.time);
                setGuests(data.guests);
                setStatus(data.status);
                if (data.email.length > 0) {
                    setEmail(data.email);
                    setEmailMessage('Письмо успешно отправлено!');
                }
                if (data.phone != 'Номер не указан')
                    setPhone(data.phone);
            }).finally(() => {
                setIsLoading(false);
                setIsLoaded(true);
            });
    }, []);

    return (
        <>
            <LoadingAnimation isLoading={isLoading}></LoadingAnimation>
            {
                isLoaded && (
                    <div className='show-reserve'>
                        <h1 className="header-form__title message__title">Ваше бронирование</h1>

                        <div className="message__item">
                            <img src={CalendarIcon} alt="" />
                            <span className="message__text" id="message-date-time">{getMomentTimeFromUTC(date).format('DD.MM.YY В HH:mm')}</span>

                        </div>

                        <div className="message__item">
                            <img src={UserIcon} alt="" />
                            <span className="message__text" id="message-guests"> На {guests} гост(-ей)я</span>
                        </div>

                        <div className="message__item">
                            <img src={PlaceIcon} alt="" />
                            <span className="message__text">
                                <span id="message-rest"> {restaurantName}, {address}</span>
                            </span>
                        </div>
                        {phone && (
                            <div className="message__item ">
                                <img src={PhoneIcon} alt="" />
                                <span className="message__text">
                                    {phone}
                                </span>
                            </div>
                        )}
                        <div className="message__item ">
                            <span className="message__text">
                                Статус:
                                {getStatusSpan()}
                            </span>
                        </div>



                        {status && status != 'Отменено гостем' && status != 'Отменено администратором' && status != 'Завершено' && (

                            <div className='show-reserve__buttons' >
                                <input value={email} onChange={(e) => { setEmail(e.target.value) }} id="mailTo" name="mailTo" className="message__email" type="email" placeholder="Ваш email" />

                                <button className="message__btn message__btn-send" type="submit" onClick={sendEmail}>{emailMessage || 'Отправить на электронную почту'}</button>

                                <button className="message__btn message__btn-send-tg" onClick={sendTelegram}>
                                    <span>Отправить в Telegram</span>
                                    <img src={TgIcon} height={40} alt="" />
                                </button>

                                <button type="submit" className="message__btn message__btn-cancel" onClick={cancellReserve}>Отменить бронирование</button>
                            </div>

                        )}
                    </div>
                )}
            {/* <div className="container">
                {status && (
                    <div className="form message">
                        <h1 className="header-form__title message__title">Ваше бронирование</h1>

                        <div className="message__item">
                            <img src={CalendarIcon} alt="" />
                            <span className="message__text" id="message-date-time">{moment(date).format('DD.MM.YY В HH:mm')}</span>

                        </div>

                        <div className="message__item">
                            <img src={UserIcon} alt="" />
                            <span className="message__text" id="message-guests"> На {guests} гост(-ей)я</span>
                        </div>

                        <div className="message__item">
                            <img src={PlaceIcon} alt="" />
                            <span className="message__text">
                                Ресторан
                                <span id="message-rest"> {restaurantName}, {address}</span>
                            </span>
                        </div>


                        <div className="message__item ">
                            <span className="message__text">
                                Статус:
                                {getStatusSpan()}
                            </span>
                        </div>
                        {status && status != 'Отменено гостем' && status != 'Отменено администратором' && status != 'Завершено' && (
                            <>
                                <div className="message__btns">
                                    <form id="emailform" className="message__input" method="get">
                                        <input value={email} onChange={(e) => { setEmail(e.target.value) }} id="mailTo" name="mailTo" className="message__email" type="email" placeholder="Ваш email" />
                                        <input className="message__btn message__btn-send" type="submit" value="Отправить на электронную почту" onClick={sendEmail} />
                                    </form>
                                    <form method="post">
                                        <input type="submit" className="message__btn message__btn-cancel" value="Отменить бронирование" onClick={cancellReserve} />
                                    </form>
                                </div>
                                <span className='email-span' style={{ textAlign: 'center' }}>{emailMessage}</span>
                            </>
                        )}

                    </div>
                )}
            </div> */}
        </>
    );
}
export default ShowReserve;